import { Injectable } from '@angular/core';

import { TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';

import { MultiBuilderTracking } from './multi-builder.model';

@Injectable()
export class MultiBuilderTrackingService {
    restrictCompetitionSwitchTrack = false;
    constructor(private trackingService: TrackingService) {}

    trackMarKetSwitch(marketID: string): void {
        this.trackingService.track(trackingConstants.EVENT_MARKET_SWITCH, {
            [trackingConstants.MARKET_ID]: marketID,
        });
    }

    trackCompetitionSwitch(sportID: number): void {
        if (this.restrictCompetitionSwitchTrack) {
            return;
        }
        this.trackingService.track(trackingConstants.EVENT_NAVIGATION_MENUS, {
            [trackingConstants.PAGE_NAVIGATION_MENUS]: `${MultiBuilderTracking.MultiBuilderNav}${sportID}`,
        });
    }

    trackBetSlipErrors(): void {
        this.trackingService.track(trackingConstants.EVENT_BETSLIP_ERROR, {
            [trackingConstants.PAGE_BETSLIP_ERROR]: MultiBuilderTracking.BetSlipErrors,
        });
    }
}
